import PropTypes from 'prop-types'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import { FormControl } from 'baseui/form-control'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'

const GenericInputField = ({ hidden, error, caption, isEditable, value, onBlur, label, id }) => {
  if (hidden) {
    return null
  }
  return (
    <FormControl error={error} caption={caption}>
      <SDInput
        label={label}
        disabled={isEditable === false}
        id={id}
        onBlur={onBlur}
        currentValue={value}
        endEnhancer={<CopyEndEnhancer value={value} />}
      />
    </FormControl>
  )
}

GenericInputField.propTypes = {
  hidden: PropTypes.bool,
  error: PropTypes.string,
  caption: PropTypes.string,
  isEditable: PropTypes.bool,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  id: PropTypes.string,
}

export default GenericInputField
